// Mirrors the longlinks shortener lambda's base48 alphabet.
// Vowels, l, 0, 1, 3 are intentionally omitted to avoid bad words and transcription ambiguity.
// Source: longlinks_shortener/api/store.js (variable `base48HashChars`).
export const BASE48_ALPHABET = '2456789bcdfghjkmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ';
